import React from 'react';

export function CircleChevronRight({
	className,
}: {
	className?: string;
}): JSX.Element {
	return (
		<svg className={className} xmlns="http://www.w3.org/2000/svg" fill="none" height="15" width="14"><g fill="#000" clipPath="url(#a)"><path fillOpacity=".1" d="M14 7.5a7 7 0 1 1-14 0 7 7 0 0 1 14 0ZM5.469 4.656c0 .167.063.337.191.465L8.04 7.5 5.66 9.879a.652.652 0 0 0-.191.465.651.651 0 0 0 .656.656c.17 0 .336-.063.465-.191l2.844-2.844a.652.652 0 0 0 .191-.465.652.652 0 0 0-.191-.465L6.59 4.191A.652.652 0 0 0 6.125 4a.652.652 0 0 0-.656.656Z"/><path fillOpacity=".61" d="M9.434 7.035a.654.654 0 0 1 0 .927L6.59 10.808a.656.656 0 0 1-.927-.927l2.38-2.379-2.38-2.378a.656.656 0 0 1 .927-.927l2.844 2.838Z"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h14v15H0z"/></clipPath></defs></svg>
	);
}
